"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEntry = void 0;
var editor_elements_conventions_1 = require("@wix/editor-elements-conventions");
var RegistryError_1 = require("../../errors/RegistryError");
var libraries_1 = require("../../libraries");
var createEagerEntry_1 = require("./createEagerEntry");
var createLazyEntry_1 = require("./createLazyEntry");
var createRegistryDataTransport_1 = require("./createRegistryDataTransport");
function getHostManifests(host, manifests) {
    return manifests
        .filter(function (manifest) { return !!manifest.hosts[host]; })
        .map(function (manifest) {
        return {
            manifest: manifest.hosts[host],
            library: manifest.library,
        };
    });
}
function getRegistryRuntime(manifests, host, entryRuntime) {
    return {
        info: entryRuntime.info,
        libraries: manifests.map(function (manifest) {
            var _a;
            return ({
                library: manifest.library,
                hosts: (_a = {},
                    _a[host] = manifest.hosts[host],
                    _a),
            });
        }),
    };
}
function createEntry(_a) {
    var _this = this;
    var host = _a.host, _b = _a.libraryAssetsPatterns, libraryAssetsPatterns = _b === void 0 ? [] : _b;
    return function (params) { return __awaiter(_this, void 0, void 0, function () {
        var _a, mode, _b, batches, libraries, _c, options, _d, transport, _e, shouldLoadCSSAssets, libraryManifests, manifests, _f, infoManifests, entryRuntime, entryRuntime, e_1;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    _a = params.mode, mode = _a === void 0 ? 'lazy' : _a, _b = params.batches, batches = _b === void 0 ? ['bootstrap'] : _b, libraries = params.libraries, _c = params.options, options = _c === void 0 ? {} : _c, _d = params.transport, transport = _d === void 0 ? createRegistryDataTransport_1.createRegistryDataTransport() : _d, _e = params.shouldLoadCSSAssets, shouldLoadCSSAssets = _e === void 0 ? false : _e;
                    if (!libraries || !libraries.length) {
                        throw RegistryError_1.createException('"libraries" is required property to create the registry', RegistryError_1.RegistryErrorCode.IncorrectEntryArguments);
                    }
                    if (!params.registerComponent && !params.registerLibrary) {
                        throw RegistryError_1.createException('"registerComponent" or "registerLibrary" should be passed to the registry', RegistryError_1.RegistryErrorCode.IncorrectEntryArguments);
                    }
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 9, , 10]);
                    return [4 /*yield*/, libraries_1.loadAndParseLibraries({
                            transport: transport,
                            libraries: libraries,
                            libraryAssetsPatterns: libraryAssetsPatterns,
                            options: options,
                        })];
                case 2:
                    libraryManifests = _g.sent();
                    manifests = getHostManifests(host, libraryManifests);
                    _f = mode;
                    switch (_f) {
                        case 'lazy': return [3 /*break*/, 3];
                        case 'eager': return [3 /*break*/, 5];
                    }
                    return [3 /*break*/, 7];
                case 3:
                    infoManifests = getHostManifests(editor_elements_conventions_1.getInfoHostName(host), libraryManifests);
                    return [4 /*yield*/, createLazyEntry_1.createLazyEntry({
                            manifests: manifests,
                            infoManifests: infoManifests,
                            transport: transport,
                        })(__assign(__assign({}, params), { shouldLoadCSSAssets: shouldLoadCSSAssets, batches: batches }))];
                case 4:
                    entryRuntime = _g.sent();
                    return [2 /*return*/, getRegistryRuntime(libraryManifests, host, entryRuntime)];
                case 5: return [4 /*yield*/, createEagerEntry_1.createEagerEntry({
                        manifests: manifests,
                        transport: transport,
                    })(__assign(__assign({}, params), { shouldLoadCSSAssets: shouldLoadCSSAssets }))];
                case 6:
                    entryRuntime = _g.sent();
                    return [2 /*return*/, getRegistryRuntime(libraryManifests, host, entryRuntime)];
                case 7: throw RegistryError_1.createException('Unknown "mode" value', RegistryError_1.RegistryErrorCode.IncorrectEntryArguments).withMissMatch(mode, 'lazy | eager');
                case 8: return [3 /*break*/, 10];
                case 9:
                    e_1 = _g.sent();
                    if (options.dev && !(e_1 instanceof RegistryError_1.RegistryError)) {
                        console.error("Registry Unexpected Exception \u2013 \"" + e_1.message + "\".\nPlease notify registry developers about this error.");
                    }
                    throw e_1;
                case 10: return [2 /*return*/];
            }
        });
    }); };
}
exports.createEntry = createEntry;
exports.default = createEntry;
//# sourceMappingURL=createEntry.js.map